import PropTypes from 'prop-types';
import { useState } from 'react';
import H3 from 'UIComponents/elements/headings/H3';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIForm from 'UIComponents/form/UIForm';
import UIModal from 'UIComponents/dialog/UIModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18n = key => `knowledgeContentUI.templateEditor.confirmDeletionModal.${key}`;
function ConfirmDeletionModal({
  onClose,
  onDeleteConfirm
}) {
  const [neverShowDeletionModal, setNeverShowDeletionModal] = useState(false);
  const toggleNeverShowAgain = ({
    target: {
      checked
    }
  }) => setNeverShowDeletionModal(checked);
  return /*#__PURE__*/_jsx(UIModal, {
    centered: true,
    use: "conversational",
    width: 600,
    children: /*#__PURE__*/_jsxs(UIForm, {
      onSubmit: () => {
        onDeleteConfirm(neverShowDeletionModal);
      },
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        className: "text-start m-bottom-3",
        children: /*#__PURE__*/_jsxs(UIFlex, {
          justify: "start",
          children: [/*#__PURE__*/_jsx(H3, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18n('header')
            })
          }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
            onClick: onClose
          })]
        })
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        className: "text-start",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18n('bodyText')
        }), /*#__PURE__*/_jsx(UICheckbox, {
          defaultChecked: false,
          onClick: toggleNeverShowAgain,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18n('showModalAgain')
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        align: "left",
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          type: "submit",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18n('delete')
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18n('cancel')
          })
        })]
      })]
    })
  });
}
ConfirmDeletionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDeleteConfirm: PropTypes.func.isRequired
};
export default ConfirmDeletionModal;